import React from 'react';
import { faChevronRight, faEdit, faRetweet, faStop } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { filterOptions, FilterType, jobQuery } from 'components/breadcrumbs/constants';
import { MegaMenu } from 'components/mega-menu/megaMenu';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { getJob } from 'ducks/job/operators';
import { selectJob } from 'ducks/job/selectors';
import { setModal } from 'ducks/modals/slices';
import { selectProject } from 'ducks/project/selectors';
import { selectProjects } from 'ducks/projects/selectors';
import { updateSettings } from 'ducks/settings/slices';
import { Link, useParams } from 'react-router-dom';
import { handleError } from 'utils/errors';
import { replaceSearchQuery } from 'utils/queries';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

interface ParamsProps {
  project_id?: number;
  filter?: FilterType;
}

export const Job = () => {
  const dispatch = useAppDispatch();
  const { project_id, filter }: ParamsProps = useParams();

  const job = useAppSelector(selectJob);
  const project = useAppSelector(selectProject);
  const projects = useAppSelector(selectProjects);

  const getJobsRoute = () => {
    const query = replaceSearchQuery(jobQuery);
    return `/projects/${project_id}/jobs/all${query}`;
  };
  const handleParams = (filter: FilterType) => {
    return filterOptions[filter as keyof typeof filter];
  };
  const runJob = async () => {
    try {
      dispatch(setModal({ run_job_definition: true }));
    } catch (err) {
      handleError(err);
    }
    dispatch(updateSettings({ loading: false }));
  };

  const editJob = async () => {
    try {
      const { job_id } = job;
      if (job_id) {
        await dispatch(getJob(job_id));
      }
      await dispatch(setModal({ edit_job: true }));
    } catch (err) {
      handleError(err);
    }
    dispatch(updateSettings({ loading: false }));
  };

  const stopJob = async () => {
    try {
      const { job_id } = job;
      if (job_id) {
        await dispatch(getJob(job_id));
      }
      dispatch(setModal({ stop_job: true }));
    } catch (err) {
      handleError(err);
    }
    dispatch(updateSettings({ loading: false }));
  };

  const { job_state_id } = job;
  const job_state = filter && handleParams(filter);
  const project_name = `${project.project_name ?? 'Projects'}`;
  return (
    <div className={cn.items}>
      <MegaMenu labels={project_name} values={projects} page="job" />
      <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
      <Link className={cn.item} to={getJobsRoute()}>
        Jobs: {job_state}
      </Link>
      <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
      <p className={cn.item}>Job: {job.job_id}</p>
      <div className={cn.flexGrow} />
      <div className={cn.actionJob}>
        <div className={cn.action} onClick={editJob}>
          <FontAwesomeIcon size="sm" icon={faEdit} />
          <span className={cn.actionText}>Edit</span>
        </div>
        <div className={cn.action} onClick={runJob}>
          <FontAwesomeIcon className={cn.retweetIcon} icon={faRetweet} />
          <div className={classNames(cn.actionText, cn.actionTextRerun)}>Re-run</div>
        </div>
        {job_state_id && job_state_id <= 3 && (
          <div className={cn.action} onClick={stopJob}>
            <FontAwesomeIcon icon={faStop} color="#d9534f" />
            <span className={cn.actionText}>Stop</span>
          </div>
        )}
      </div>
    </div>
  );
};
